import React from 'react'

const Podcast = () => {
  return (
    <div className='podcast__card'>
        <div className='podacst__header'>
            <div className='podcast__header-image'></div>
            <div className='podcast__header-text-container'>
                <div className='podcast__header-text'></div>
                <div className='podcast__header-subtext'></div>
            </div>
        </div>
        <div className='podcast__image'></div>
        <div className='podcast__footer-text'></div>
        <div className='podcast__footer-icon-component'></div>
    </div>
  )
}

export default Podcast